<template>
  <div>
    <div class="img-box">
      <ul id="picViewer" class="uploader_files flex">
        <li v-for="(item, index) in picList" :key="index" class="uploader_file_block">
          <!-- 文档文件 -->
          <div v-if="_isDocumentFileFormat(item.url)">
            <a :href="item.url" class="doc-class" />
          </div>
          <!-- PDF文件 -->
          <div v-else-if="_isPDFFileFormat(item.url)">
            <a
              :href="'/app/case/createPdfStream/?urlPath=' + item.url"
              target="_blank"
              class="pdf-class"
            />
          </div>
          <!-- tif、tiff特殊文件 -->
          <div
            v-else-if="_isTifFileFormat(item.url)"
            :id="'canvas_' + index"
            @click="imgViewDialog_show(item)"
          />
          <!-- MP3音频文件 -->
          <div v-else-if="_isMP3FileFormat(item.url)">
            <a :href="item.url" target="_blank" class="mp3-class" />
          </div>
          <!-- 视频文件 -->
          <div
            v-else-if="checkVideo(item.url)"
            style="max-width: 400px; max-height: 200px"
          >
            <video
              align="center"
              mediatype="video"
              :preload="video.preload"
              :poster="video.videoImg"
              :height="video.height"
              :width="video.width"
              :controls="video.controls"
              :src="item.url"
            />
          </div>
          <div v-else>
            <img
              class="uploader_file"
              :src="`${item.url}?imageView2/1/w/130/h/130/q/85`"
              :data-original="`${item.url}?imageView2/2/w/1200/h/1200/q/85`"
            >
          </div>
          <span class="uploader_file_name">{{ item.name }}</span>
        </li>
      </ul>
    </div>

    <!-- 针对特殊图片格式而显示的canvas图 -->
    <div v-if="imgViewDialogVisible" class="registerPart">
      <i class="el-icon-circle-close el-close_m" @click="imgViewDialog_close" />

      <div id="canvas_main" class="canvas-content" />
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'

export default {
  data() {
    return {
      picList: [],
      picListViewer: null,
      imgViewDialogVisible: false, // 控制dialog显示隐藏
      imgViewDialog_imgSrc: '', // 控制图片src

      // 视频默认格式
      video: {
        videoImg:
          'http://ehuzhu-1251082375.cos.ap-guangzhou.myqcloud.com/cms/7c6c9485913cc8c91ae8.png',
        playStatus: '',
        muteStatus: '',
        isMute: true,
        isPlay: false,
        width: '125', // 设置视频播放器的显示宽度（以像素为单位）
        height: '125', // 设置视频播放器的显示高度（以像素为单位）
        preload: 'auto', //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        controls: true // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      },
      // 视频/音频文件格式
      imageTypes: [
        'mp4',
        'MP4',
        'wma',
        'mpeg',
        'avi',
        'mov',
        'flv',
        'f4v',
        'rmvb',
        'mp3'
      ]
    }
  },

  created() {
    this.show()
  },

  methods: {
    show() {
      const vm = this
      const { caseCode, type } = vm.$route.query

      vm.axios
        .get(
          vm.homePath() +
            '/casesCommon/getImageByCaseCode?imageType=' +
            type +
            '&caseCode=' +
            caseCode
        )
        .then((res) => {
          const resData = res && res.data
          if (resData && resData.status === '000000') {
            if (resData.result != null) {
              const {
                AddMaterialPlainPhoto,
                AddMaterialThankPhoto,
                AddMaterialSMSPhoto,
                AddMaterialReceiptPhoto,
                AddMaterialDailyPhoto
              } = resData.result

              if (String(type) === 'AddMaterial') {
                if (AddMaterialPlainPhoto != null) {
                  vm.pushToList(vm.filterData(AddMaterialPlainPhoto), vm.picList)
                }

                if (AddMaterialThankPhoto != null) {
                  vm.pushToList(vm.filterData(AddMaterialThankPhoto), vm.picList)
                }

                if (AddMaterialSMSPhoto != null) {
                  vm.pushToList(vm.filterData(AddMaterialSMSPhoto), vm.picList)
                }

                if (AddMaterialReceiptPhoto != null) {
                  vm.pushToList(vm.filterData(AddMaterialReceiptPhoto), vm.picList)
                }

                if (AddMaterialDailyPhoto != null) {
                  vm.pushToList(vm.filterData(AddMaterialDailyPhoto), vm.picList)
                }
                for (let i = 0; i < vm.picList.length; i++) {
                  vm.tiffImage(vm.picList[i].url, 'canvas_' + i, false)
                }
              } else {
                vm.picList = vm.filterData(resData.result)
              }

              for (let i = 0; i < vm.picList.length; i++) {
                vm.tiffImage(vm.picList[i].url, 'canvas_' + i, false)
              }

              setTimeout(() => {
                const pictures = document.getElementById('picViewer')
                // eslint-disable-next-line no-undef
                vm.picListViewer = new Viewer(pictures, {
                  title: false,
                  url: 'data-original'
                })
              }, 500)
            }
          } else {
            vm.$alert(resData && resData.message, '提示', {
              callback: () => {
                vm.$router.go(-1)
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 过滤数据
     */
    filterData(list) {
      const newList = []
      for (let i = 0; i < list.length; i++) {
        const url = this._caseConversion(list[i].url) // 文件地址
        if (
          url.substr(-3).includes('doc') ||
          url.substr(-4).includes('docx') ||
          url.substr(-3).includes('pdf') ||
          url.substr(-3).includes('mp3')
        ) {
          // Do something about it
        } else {
          newList.push(list[i])
        }
      }
      return newList
    },

    /**
     * 把对象一个个push到集合中，不然集合中的对象为图片集显示时会有问题
     */
    pushToList(list, picList) {
      for (let i = 0; i < list.length; i++) {
        picList.push(list[i])
      }
    },

    /**
     * 图片dialog_显示
     */
    imgViewDialog_show(item) {
      if (document.getElementById('canvas_main') !== null) {
        const tag = document.getElementById('canvas_main').getElementsByTagName('canvas')
        if (tag.length === 1) {
          document
            .getElementById('canvas_main')
            .removeChild(
              document.getElementById('canvas_main').getElementsByTagName('canvas')[0]
            )
        }
      }
      this.imgViewDialogVisible = true
      this.tiffImage(item.url, 'canvas_main', true)
    },

    /**
     * 图片dialog_关闭
     */
    imgViewDialog_close() {
      this.imgViewDialogVisible = false
    },

    /**
     * 将canvas画布内容显示在指定元素上
     */
    setTif({ canvas, id }) {
      document.getElementById(id).append(canvas)
    },

    /**
     * 将tif/tiff格式的文件转换成canvas画布内容
     * @param {string} url 文件的网络地址
     * @param {string} id 元素的ID值
     * @param {string} status 渲染canvas的状态（true：放大预览图中的canvas，false：缩略图列表中的canvas）
     */
    tiffImage(url, id, status) {
      if (!status) {
        const tag = document.getElementById(id)
        if (tag !== null) {
          return
        }
      }

      if (common.hasTiff(url)) {
        this.$nextTick(() => {
          let params = { url, w: 125, h: 125, isScale: true }
          if (status) {
            params = { url, w: 625, h: 625, isScale: false }
          }

          common.getTif(params).then((res) => {
            if (res) {
              this.setTif({ canvas: res, id })
            }
          })
        })
      }
    },

    /**
     * 检查视频/音频文件格式是否正确
     * @param {string} url 文件的网络地址
     */
    checkVideo(url) {
      let type = url.substring(url.lastIndexOf('.') + 1, url.length)
      type = this._caseConversion(type)
      return this.imageTypes.indexOf(type) !== -1
    },

    /**
     * 判断当前文件是否为tif/tiff的文件格式
     * @param {string} url 文件的网络地址
     */
    _isTifFileFormat(url) {
      url = this._caseConversion(url)
      if (url && (url.substr(-3).includes('tif') || url.substr(-4).includes('tiff'))) {
        return true
      } else {
        return false
      }
    },

    /**
     * 判断当前文件是否为文档的文件格式
     * @param {string} url 文件的网络地址
     */
    _isDocumentFileFormat(url) {
      url = this._caseConversion(url)
      if (url && (url.substr(-3).includes('doc') || url.substr(-4).includes('docx'))) {
        return true
      } else {
        return false
      }
    },

    /**
     * 判断当前文件是否为PDF的文件格式
     * @param {string} url 文件的网络地址
     */
    _isPDFFileFormat(url) {
      url = this._caseConversion(url)
      if (url && (url.substr(-3).includes('pdf'))) {
        return true
      } else {
        return false
      }
    },

    /**
     * 判断当前文件是否为MP3的文件格式
     * @param {string} url 文件的网络地址
     */
    _isMP3FileFormat(url) {
      url = this._caseConversion(url)
      if (url && (url.substr(-3).includes('mp3'))) {
        return true
      } else {
        return false
      }
    },

    /**
     * 将文件名转小写字母
     */
    _caseConversion(name) {
      return name.toLowerCase()
    }
  }
}
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.uploader_files {
  flex-wrap: wrap;
  align-items: flex-start;

  .uploader_file_block {
    width: 128px;
    box-sizing: content-box !important;
  }
}

.img-box {
  width: 1000px;
  margin: 0 auto;
}

.registerPart {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  overflow-y: auto;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.el-close_m {
  position: absolute;
  top: 4px;
  left: 97.5%;
  font-size: 28px !important;
}

.canvas-content {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

body {
  font-size: 16px !important;
}
</style>
